/**
 * Gender options
 */
const AVAILABLE_GENDERS = {
  man: "male",
  woman: "female",
  unknown: "unknown",
  diverse: "diverse",
};

const CHILD_AGE = {
  child: "child",
  teen: "teen",
};

const GENDER_OPTIONS = [
  { label: "Man", value: "male" },
  { label: "Woman", value: "female" },
  { label: "Gender diverse", value: "diverse" },
  { label: "Prefer not to say", value: "unknown" },
];

const BOY_CHILD_IMAGES = [
  {
    id: 0,
    image: "avatars/boy-1",
  },
  {
    id: 1,
    image: "avatars/boy-2",
  },
  { id: 2, image: "avatars/boy-3" },
  { id: 3, image: "avatars/boy-4" },
  { id: 4, image: "avatars/boy-5" },
  { id: 5, image: "avatars/boy-6" },
];

const BOY_TEEN_IMAGES = [
  { image: "avatars/teen-boy-1" },
  { image: "avatars/teen-boy-2" },
  { image: "avatars/teen-boy-3" },
  { image: "avatars/teen-boy-4" },
  { image: "avatars/teen-boy-5" },
  { image: "avatars/teen-boy-6" },
];

const GIRL_CHILD_IMAGES = [
  { id: 6, image: "avatars/girl-1" },
  { id: 7, image: "avatars/girl-2" },
  { id: 8, image: "avatars/girl-3" },
  { id: 9, image: "avatars/girl-4" },
  { id: 10, image: "avatars/girl-5" },
  { id: 11, image: "avatars/girl-6" },
];

const GIRL_TEEN_IMAGES = [
  "avatars/girl-1",
  "avatars/girl-2",
  "avatars/girl-3",
  "avatars/girl-4",
  "avatars/girl-5",
  "avatars/girl-6",
];

const GENDER_NEUTRAL_IMAGES = [];

export {
  GENDER_NEUTRAL_IMAGES,
  GENDER_OPTIONS,
  AVAILABLE_GENDERS,
  CHILD_AGE,
  BOY_CHILD_IMAGES,
  GIRL_CHILD_IMAGES,
  GIRL_TEEN_IMAGES,
  BOY_TEEN_IMAGES,
};
